import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';

const WideTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 600
    }
});

export default WideTooltip;
